import axiosConfig from "./axiosConfig";

export interface BillingConfigEntry {
  id: number;
  siteId: string;
  esysUuid: string;
  start: string;
  end: string;
  method: string;
  demandScalingFactor: number;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface SiteBillingConfigResponse {
  entries: BillingConfigEntry[];
}

const getSiteBillingConfig = async (
  authToken: string,
  siteId: string
): Promise<SiteBillingConfigResponse> => {
  const { data } = await axiosConfig.get(`/site/${siteId}/billing_config`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getSiteBillingConfig;
